/* RESPONSIBLE TEAM: team-inbox */
import { isEmpty } from '@ember/utils';

let orderNameRegex = /^#?[0-9]+$/;

export function isValidOrderName(orderName) {
  return isEmpty(orderName) ? false : orderNameRegex.test(orderName);
}
